import { render, staticRenderFns } from "./selectField.vue?vue&type=template&id=4811a0f8&"
import script from "./selectField.vue?vue&type=script&lang=ts&"
export * from "./selectField.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports